import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";

let quicks = [];

const QuickAnswer = ({
          buttonQuickAnswer,
          setButtonQuickAnswer,
          bind,
          changeTextQuill,
          screen
      }) => {
        const  [filter, setFilter] = useState("");
        const  RespostasRapidas = useSelector(state => state.respostas);
    
    quicks = RespostasRapidas.respostas !== undefined ? RespostasRapidas.respostas:[];

    const sendingTextBoxMail = (event,qck_asw_answer,bind,editable,mimetypeid) => {
        changeTextQuill(
            event,
            qck_asw_answer,
            bind,
            editable,
            mimetypeid,
            screen
        )
        setButtonQuickAnswer(false);
    }

    if(filter !== ""){
        const list = quicks || [];
        quicks = list;
        quicks = _.filter(list, quick => {
          let arrayQuick = [
            quick.qck_asw_keyword
          ];
          return !_.isEmpty(filter)
            ? arrayQuick.toString().toLowerCase().indexOf(filter.toString().toLowerCase()) >
                -1
            : true;
        });
    }

    return (
            <div
                className={
                    buttonQuickAnswer
                    ? "premade-msg active"
                    : "premade-msg"
                }
                style={{zIndex: 9999999999999}}
            >
                <p className="premade-msg__title" onClick={() => setButtonQuickAnswer(false)}>Mensagens Predefinidas</p>
                <div className="premade-msg__content">
                    <ul className="premade-msg__list">
                    {quicks.map(resp => (
                        <li
                        key={resp.qck_asw_id}
                        className="premade-msg__item"
                        onClick={event =>
                            sendingTextBoxMail(
                                event,
                                resp.qck_asw_answer,
                                bind,
                                resp.editable,
                                resp.mimetypeid,
                            )
                        }
                        >
                        {resp.qck_asw_keyword}
                        </li>
                    ))}
                    </ul>
                    <div className="premade-msg__input-wrapper">
                    <input
                        type="text"
                        className="premade-msg__search-input"
                        id="input-msgs-rapidas"
                        onChange={event =>
                            setFilter(event.target.value)
                        }
                        placeholder="Pesquise uma resposta..."
                    />
                    <span className="premade-msg__input-icon">
                        <i className="material-icons">search</i>
                    </span>
                    </div>
                </div>
            </div>
    );
  };
  
  export default QuickAnswer;
  